import React from 'react';
import './Page.css';

/**
 * Baustein 9 — Page.
 * Standard-Container für jede Seite. Setzt Padding und Page-Hintergrund.
 * Macht keine Annahmen über den Inhalt — ActionBar, FilterStrip, beliebige Sections
 * können als Children eingesetzt werden.
 *
 * Props:
 *   width — 'default' (max-width 1380px, zentriert) | 'full' (keine max-width,
 *           ganze Viewport-Breite). Default 'default'.
 *           Für Pages mit großem Karten-Grid (Sammlung) ist 'full' richtig,
 *           damit der Grid die ganze Fenster-Breite ausnutzt.
 *
 * Verwendung:
 *   <Page>                  <-- max-width 1380px (Standard)
 *   <Page width="full">     <-- volle Breite
 */
export default function Page({ width = 'default', className = '', children }) {
  const classes = `page page--${width}${className ? ` ${className}` : ''}`;
  return <div className={classes}>{children}</div>;
}
